<template>
  <div>
    <div class="ec-bind-tips">
      <icon-font style="font-size: 14px; margin-right: 6px" type="gb-icon-Info" />
      {{ $t('common_login_首次登录需绑定') }}
    </div>
    <a-form-model class="ec-bind-form switch-form" :model="form" :rules="rules" ref="dataForm" hideRequiredMark :colon="false" labelAlign="left">
      <!-- 手机号 -->
      <a-form-model-item prop="phone" :label="$t('common_form_phone')" htmlFor="phone" class="input-addon-before-form-item">
        <a-input
          autoComplete="off"
          v-model="form.phone"
          :maxLength="11"
          @keyup="form.phone = form.phone.replace(/[^\d]/g, '')"
          v-forlogin="'phone'"
        >
          <a-select :value="form.phoneCode | disCountryCode" :dropdownMatchSelectWidth="false" slot="addonBefore" :getPopupContainer="() => $el">
            <div slot="dropdownRender" style="overflow: auto; padding: 4px 0" :style="{minWidth: currentLang === 'zh_CN' ? '260px' : '400px'}">
              <RecycleScroller
                style="max-height: 400px; min-height: 32px; overflow:auto"
                :items="countryCodeList"
                :item-size="32"
                :buffer="100"
                :prop="{value: 'index', text: 'name' + currentLangList[currentLang]}"
                @selected="changeInternational"
              >
                <template v-slot="{item}">
                  <div style="display:flex;justify-content:space-between; width:100%">
                    <span style="width: calc(100% - 70px);white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item['name' + currentLangList[currentLang === 'ko_KR' ? 'en_US' : currentLang]]}}</span>
                    <span style="margin-right:2px">+ {{item.phonecode}}</span>
                  </div>
                </template>
              </RecycleScroller>
            </div>
          </a-select>
        </a-input>
      </a-form-model-item>
      <!-- 右侧验证码 -->
      <a-form-model-item prop="imgCode" :label="$t('common_form_identifying_code')" htmlFor="imgCode" v-if="showImgCode">
        <a-input autoComplete="off" v-model="form.imgCode" :maxLength="4" v-forlogin="'imgCode'">
          <span slot="suffix" style="width:56px;height:33px;background:rgb(253, 253, 253);">
            <a-spin v-if="imgCodeLoading" size="small" style="margin-left: 25px; margin-top: 9px;" />
            <img v-else :src="imgCodeData" style="cursor:pointer; width: 100%; height: 100%" @click="getImgCode" />
          </span>
        </a-input>
      </a-form-model-item>
      <!-- 短信验证码 -->
      <a-form-model-item prop="shortMessageCode" :label="$t('common_form_sms_code')" htmlFor="shortMessageCode">
        <a-input :maxLength="6" autoComplete="off" v-model="form.shortMessageCode" v-forlogin="'shortMessageCode'">
          <a-spin slot="suffix" :spinning="isCodeLoading && !timing">
            <a-button id="captcha-button" type="link" v-show="!timing">{{$t('common_btn_send_ver')}}</a-button>
            <span v-show="timing">{{timing}} s</span>
          </a-spin>
        </a-input>
      </a-form-model-item>
      <!-- 设置密码 -->
      <!-- <a-form-model-item prop="password" :label="$t('common_form_设置密码')" htmlFor="password">
        <a-input-password autoComplete="new-password" v-model="form.password" v-forlogin="'password'"></a-input-password>
      </a-form-model-item> -->
      <!-- 邀请码（选填） -->
      <a-form-model-item prop="inviteCode" :label="$t('common_form_Invitation')" htmlFor="inviteCode">
        <a-input v-model="form.inviteCode" autoComplete="off" v-forlogin="'inviteCode'"></a-input>
      </a-form-model-item>
    </a-form-model>
    <!-- 协议 -->
    <div class="ec-bind-agreement" >
      <a-checkbox class="login-form__checkbox" v-model="agreement">
        <span>{{ $t('common_login_I_read_agress') }}</span>
        <a-button type="link" @click="$emit('agreement', 'agreementVisible')">{{ $t('common_login_ServiceAgreement') }}</a-button>
        <span>{{ $t('common_conj_and') }}</span>
        <a-button type="link" @click="$emit('agreement', 'policyVisible')">{{ $t('common_login_PrivacyPolicy') }}</a-button>
      </a-checkbox>
    </div>
    <a class="ec-bind-submit" :class="{'ec-bind-submit__loading': submitLoading}">
      <a-spin v-if="submitLoading">
        <a-icon slot="indicator" type="loading" style="font-size: 24px;  color: #fff" spin />
      </a-spin>
      <span style="flex: 1; text-align:center" v-else  @click="onSubmit" >{{ $t('common_btn_confirm') }}</span>
    </a>
    <a class="ec-bind-submit" style="background: #fff; color: #007BFC; font-size: 14px; margin-top: 10px" @click="$emit('to', 'login')">
      {{ $t('common_login_return_login') }}
    </a>

    <!-- 验证码容器 -->
    <div id="captcha-element"></div>
  </div>
</template>

<script>
import RecycleScroller from '@/components/VirtualScroll/RecycleScroller'
import { mapState } from 'vuex'
import mixins from '../mixins'
import { debounce } from '@/utils/util'
import {
  LoginCodeAvatar, // 验证码
  LoginCheckImgCode, // 手机验证码
  PhoneCodeInterface // 区号
} from '@/api/sso/code'
import { firstBindingPhoneEmailPsw } from '@/api/sso/user'

export default {
  components: {
    RecycleScroller
  },
  mixins: [mixins],
  data () {
    const validatePhone = (rule, value, callback) => {
      if (value.length < 7 || value.length > 12 || !/^[\d]+$/.test(value)) {
        callback(new Error(this.$t('common_form_please_enter', [this.$t('common_form_正确的手机号码')])))
      } else {
        callback()
      }
    }
    return {
       countryCodeList: [
        { name_zh: '中国大陆', name: 'CHINA', phonecode: '86' },
        { name_zh: '中国香港', name: 'HONG KONG', phonecode: '852' },
        { name_zh: '中国澳门', name: 'MACAO', phonecode: '853' },
        { name_zh: '中国台湾', name: 'TAIWAN', phonecode: '886' },
        { name_zh: '美国', name: 'UNITED STATES', phonecode: '1' },
        { name_zh: '澳大利亚', name: 'AUSTRALIA', phonecode: '61' },
        { name_zh: '英国', name: 'UNITED KINGDOM', phonecode: '44' }
      ],
      currentLangList: {
        'en_US': '',
        'zh_CN': '_zh'
      },
      form: {
        phoneCode: '86',
        phone: ''
      },
      rules: {
        phone: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_phone')]), trigger: [] },
          { validator: validatePhone, trigger: [] }
        ],
        imgCode: [
          { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_identifying_code')]), trigger: [] },
          { length: 4, message: this.$t('common_form_please_enter', [this.$t('common_form_four-digit')]), trigger: [] }
        ],
        shortMessageCode: { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_sms_code')]), trigger: [] }
        // password: [
        //   { required: true, message: this.$t('common_form_please_enter', [this.$t('common_form_login_pd2')]), trigger: [] },
        //   { pattern: /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{8,16}$/, message: this.$t('common_form_密码格式错误'), trigger: [] }
        // ]
      },
      showImgCode: false,
      imgCodeLoading: false,
      imgCode: '',
      imgCodeData: '',
      timing: 0,
      isCodeLoading: false,
      agreement: false, // 请阅读并勾选协议
      submitLoading: false
    }
  },
  filters: {
    disCountryCode (val) {
      return `+ ${val}`
    }
  },
  computed: {
    ...mapState({
      currentLang: state => state.app.lang
    })
  },
  methods: {
    // 选择区号
    changeInternational (val) {
      this.form.phoneCode = val.phonecode
    },
    onSubmit () {
      if (!this.agreement) {
        this.$message.warning(this.$t('common_form_请阅读并勾选协议'))
        return
      }
      this.$refs['dataForm'].validate((flag, errors) => {
        if (!flag) return this.$message.error(errors[Object.keys(errors)[0]][0].message)
        this.submitLoading = true
        const params = {
          ...this.form,
          smsType: 'REGISTER',
          // secondPsw: this.form.password,
          unionId: this.$route.query.unionId,
          openId: this.$route.query.openId
        }
        firstBindingPhoneEmailPsw(params).then(({ data, message }) => {
          if (!data?.token) {
            this.$message.warning(message)
            return
          }
          if (this.$route.query.systemCode) {
            this.$emit('done', {
              path: `/company/serve/buy-serve?systemCode=${this.$route.query.systemCode}`
            })
          } else {
            this.$emit('done', {
              path: '/user/home'
            })
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },

    getImgCode () {
      this.imgCodeLoading = true
      debounce(() => {
        LoginCodeAvatar().then(({ data }) => {
          this.form.imgCodeKey = data.imgCodeKey
          this.imgCodeData = data.imgCodeData
        })
          .finally(() => {
            this.imgCodeLoading = false
          })
      }, 500)
    },
    getShortMessageCode (captchaVerifyParam) {
      const {
        form: {
          phone,
          phoneCode,
          imgCode,
          imgCodeKey
        }
      } = this
      let error = 0
      this.$refs['dataForm'].validateField(['phone', 'imgCode'], message => {
        if (message) {
          error = true
          this.$message.warning(message)
        }
      })
      if (!error) {
        this.isCodeLoading = true
        LoginCheckImgCode({
          captchaVerifyParam,
          imgCode,
          imgCodeKey,
          phoneCode,
          phone,
          smsType: this.$route.query.openId ? 'BIND' : this.$route.query.unionId ? 'BINDDING' : ''
        }).then(item => {
          this.timing = 60
          this.countdown()
        }).catch(({ message, data }) => {
          if (data?.phoVc) {
            this.showImgCode = true
          }
          this.getImgCode()
        }).finally(() => {
          this.isCodeLoading = false
        })
      }
    },
    countdown () {
      const { timing } = this
      if (timing > 0) {
        setTimeout(() => {
          this.timing = timing - 1
          this.countdown()
        }, 1000)
      }
    },
    initCaptcha () {
      if (!window.initAliyunCaptcha) {
        this.$message.warning('阿里云验证码JS未加载')
        return
      }

      this.$nextTick(() => {
        window.initAliyunCaptcha({
          SceneId: 'qbz2hcw3',
          mode: 'popup',
          element: '#captcha-element',
          button: '#captcha-button',
          // 验证成功回调
          success: (captchaVerifyParam) => {
            this.getShortMessageCode(captchaVerifyParam)
          },
          // 验证失败回调
          fail: (error) => {
            console.log('验证码验证失败:', error)
          },
          slideStyle: {
            width: 360,
            height: 40
          },
          language: 'cn'
        })
      })
    }
  },
  mounted () {
    PhoneCodeInterface({}).then(({ data }) => { // 区号
      this.countryCodeList = JSON.parse(data.result).map((item, index) => ({ ...item, index }))
    }).finally(() => {
      this.form.phoneCode = this.countryCodeList[0].phonecode
    })
    this.initCaptcha()
  }
}
</script>

<style lang="less" scoped>
@color: #077BFC;
/deep/.@{ant-prefix}-select-selection {
  .@{ant-prefix}-select-selection__rendered {
    margin: 0 30px 0 0;
  }
}
.ec-bind-tips {
  margin-bottom: 20px;
  line-height: 30px;
  background: rgba(11, 177, 255, 0.08);
  border: 1px solid rgba(0, 158, 255, 0.5);
  border-radius: 5px;
  display: flex;
  padding: 0 12px;
  align-items: center;
  font-size: 12px;
}
.ec-bind {
  &-form {
    input {
      width: 100%;
    }
  }
  &-agreement {
    margin-top: 20px;
    .@{ant-prefix}-btn-link {
      margin: 0;
      padding: 0;
      height: auto;
      line-height: unset;
    }
  }
  &-submit {
    width: 100%;
    height: 55px;
    line-height: 55px;
    background: @color;
    color: #fff;
    display: flex;
    font-size: 18px;
    border-radius: 2px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    margin: 30px auto 0 auto;
    transition: all 0.5s;
    &__disable {
      background: #ddd;
      cursor: default;
    }
    &__loading {
      width: 55px;
      border-radius: 55px;
      background: fade(@color, 75%);
    }
  }
}
</style>
